// extracted by mini-css-extract-plugin
export default {"bottom":"CopyrightFooter_bottom__NAo0D","copyright":"CopyrightFooter_copyright__ITBw6","socials":"CopyrightFooter_socials__7-mz2","social":"CopyrightFooter_social__BcwUw"};